import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

import { CanLoad } from '@angular/router';
import { Route } from '@angular/router';
import { AuthenticationStorageService } from '@core/storage/jwt-storage-service';
import { AuthenticationService } from '@core/services/authentication.service';

@Injectable()
export class AuthGuard implements CanLoad, CanActivate, CanActivateChild {
    constructor(private _router: Router,
        private _authStorageService: AuthenticationStorageService,
        private _authService: AuthenticationService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this._isLoggedIn(state);
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.canActivate(route, state);
    }

    canLoad(route: Route) {
        return this._isLoggedIn();
    }

    private _isLoggedIn(state?: RouterStateSnapshot) {
        if (this._authStorageService.hasJWT()) {
            return true;
        } else {
            this._authService.logout();
            if (!!state) {
                this._router.navigate(['/account/login'], { queryParams: { returnUrl: state.url } });
            } else {
                this._router.navigate(['/account/login']);
            }
            return false;
        }
    }
}
